@let freight = freightAvailable();

@if (isLoading()) {
  <lib-skeleton-card-generic></lib-skeleton-card-generic>
  <lib-spinner-loading></lib-spinner-loading>
  <lib-skeleton-card-generic></lib-skeleton-card-generic>
} @else if (hasError() || !freight) {
  <div class="ion-text-center text-medium ion-margin-top">
    <ion-icon
      aria-hidden="true"
      class="ico-big"
      src="../assets/material-symbols/sentiment_dissatisfied_24dp.svg"
    ></ion-icon>
    <h1 class="ion-margin-top-0">
      {{ 'market.404_freight_h' | translate }}
    </h1>
  </div>
} @else if (freight) {
  @if (isNotAvailable()) {
    <div class="ion-text-center text-medium ion-margin-top">
      <ion-icon
        aria-hidden="true"
        class="ico-big"
        src="../assets/material-symbols/sentiment_dissatisfied_24dp.svg"
      ></ion-icon>
      <h1 class="ion-margin-top-0">
        {{ 'market.unavailable_freight_h' | translate }}
      </h1>
    </div>
  }

  <lib-message-ui-ionic [messages]="messages"></lib-message-ui-ionic>

  <ion-list class="block-content-round">
    <ion-item-group>
      <ion-item-divider sticky>
        <div>
          <p class="subtitle">{{ 'freight.detail.general_data' | translate }}</p>
        </div>
      </ion-item-divider>

      <div class="freight">
        <ion-grid class="ion-no-padding">
          <ion-row>
            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/payments_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">Precio</p>
                  <p class="price-container">
                    <span
                      class="price"
                      [class.notAvailable]="isNotAvailable()"
                      [class.availableWithConditions]="isAvailableWithConditions()"
                      [class.fullyAvailable]="isFullyAvailable()"
                    >
                      @if (freight.price > 0) {
                        {{ freight.price | currency: 'EUR' : 'symbol' : '1.2-2' }}
                      } @else {
                        Consultar
                      }
                    </span>
                    @if (freight.price > 0) {
                      <span class="tag price-per-kilometer">
                        ({{ freight.pricePerKilometer | currency: 'EUR' : 'symbol' : '1.2-2' }}/km)
                      </span>
                    }
                  </p>
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/local_shipping_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.vehicle_type' | translate }}</p>
                  <p>
                    @for (vehicleType of freight.vehicleTypes; track $index) {
                      <strong>{{ 'vehicleType.' + vehicleType | translate }}</strong
                      >,
                    }
                    @for (loadingType of freight.loadingTypes; track $index; let count = $count) {
                      @if ($index < count - 1) {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }},
                      } @else {
                        {{ 'freight.detail.loading_type.' + loadingType | translate | lowercase }}
                      }
                    }
                  </p>
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/weight_24dp.svg"
                ></ion-icon>
                <div>
                  <!-- <p class="subtitle">{{ 'freight.detail.weight' | translate }}</p> -->
                  <p class="subtitle">Peso aproximado</p>
                  @if (freight.weight) {
                    <p>{{ freight.weight | number: '' : 'es-ES' }} kg</p>
                  } @else {
                    <p>No disponible</p>
                  }
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/route_24dp.svg"
                ></ion-icon>
                <div>
                  <!-- <p class="subtitle">{{ 'freight.detail.weight' | translate }}</p> -->
                  <p class="subtitle">Distancia aproximada</p>
                  @if (freight.distance) {
                    <p>{{ freight.distance | number: '' : 'es-ES' }} km</p>
                  } @else {
                    <p>No disponible</p>
                  }
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/info_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.instructions' | translate }}</p>
                  @if (freight.instructions) {
                    <p>{{ freight.instructions }}</p>
                  } @else {
                    <p>Sin instrucciones específicas</p>
                  }
                </div>
              </div>
            </ion-col>

            <ion-col
              size="12"
              size-lg="6"
            >
              <div class="freight-data-block">
                <ion-icon
                  aria-hidden="true"
                  src="../assets/material-symbols/barcode_24dp.svg"
                ></ion-icon>
                <div>
                  <p class="subtitle">{{ 'freight.detail.okcargo_reference' | translate }}</p>
                  <p>{{ freight.reference }}</p>
                </div>
              </div>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </ion-item-group>
  </ion-list>

  @for (stop of freight.stops; track stop.id) {
    <lib-freight-available-detail-stop
      [stop]="stop"
      [isFreightAvailable]="isFullyAvailable() || isAvailableWithConditions()"
    ></lib-freight-available-detail-stop>
  }

  <div class="ion-text-center">
    <h4 class="more-info-title">{{ 'market.more_info' | translate }}</h4>
    <ion-button
      fill="outline"
      color="primary"
      (click)="openTrafficContact()"
    >
      {{ 'general.contact' | translate }}
    </ion-button>
  </div>

  @if (canViewPrices()) {
    <lib-fastpay-card-cta></lib-fastpay-card-cta>
  }
}
